import React from "react";
import { ImageField, Labeled, ShowProps, TextField } from "react-admin";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import Schedule from "./Schedule";
import PricingPolicyField from "./components/PricingPolicyField";
import StatusField from "../../components/StatusField";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
  },
});

const Summary = (props: ShowProps) => {
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">School Detail</Typography>

          <Button
            className={classes.summaryButton}
            variant="contained"
            color="primary"
            component={Link}
            to={{
              pathname: `/schools/${Number(props.id)}`,
            }}
            startIcon={<EditIcon />}
          >
            Edit
          </Button>
        </Grid>

        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Grid item xs={3}>
            <ImageField classes={classes} source="photoUrl" />
          </Grid>
          <Grid item xs={9}>
            <Grid item xs={12}>
              <Labeled source="Id">
                <TextField source="id" emptyText="-" />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Labeled source="Name">
                <TextField source="name" emptyText="-" />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Labeled source="Email">
                <TextField source="email" emptyText="-" />
              </Labeled>
            </Grid>

            <Grid item xs={12}>
              <Labeled source="Phone">
                <TextField source="phone" emptyText="-" />
              </Labeled>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2}>
          <Labeled source="School Prefix">
            <TextField source="schoolPrefix" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={10}></Grid>

        <Grid item xs={2}>
          <Labeled source="Type for Student Area Distance Calculation">
            <TextField source="areaDistanceCalculationType" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={10}></Grid>

        <Grid item xs={2}>
          <Labeled source="Status">
            <StatusField source="status" />
          </Labeled>
        </Grid>

        <Grid item xs={2}>
          <Labeled source="Pricing Policy">
            <PricingPolicyField source="isFullCalendarDaysCharge" />
          </Labeled>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Address</Typography>
        </Grid>

        <Grid item xs={12}>
          <Labeled source="address">
            <TextField source="address" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Block No.">
            <TextField source="blockNumber" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Unit No.">
            <TextField source="unitNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Building Name">
            <TextField source="building" emptyText="-" />
          </Labeled>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="postalCode">
            <TextField source="postalCode" emptyText="-" />
          </Labeled>
        </Grid>

        {/* <Grid item xs={12}>
          <h3 style={{ marginBottom: 0 }}>Transport Office Details</h3>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="operatingDays">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="operatingHours">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={12}>
          <Labeled source="location">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={12}>
          <h3 style={{ marginBottom: 0 }}>After-school Activity</h3>
        </Grid>

        <Grid item xs={12}>
          <Labeled source="nameActivity">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="abbreviation">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="paymentStyle">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="dropoffType">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="amountPerTrip/week">
            <TextField source="address" />
          </Labeled>
        </Grid>

        <Grid item xs={12}>
          <h3 style={{ marginBottom: 0 }}>Drop Off Authentication</h3>
        </Grid>

        <Grid item xs={6}>
          <Typography align="center">Drop-off Authorisation Type</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography align="center">Level Range</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="body2">Student MUST Be Accompanied by Parent / Guardian</Typography>
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'center' }}>
          <TextField source="address" />
        </Grid> */}
        <Grid item xs={12}>
          <Schedule {...props} />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
